import React, { Component } from 'react'
import "./App.css";
import 'bootstrap/dist/css/bootstrap.css';
import Nav from './components/Nav/Nav';
import ToastPanel from './components/Toasts/ToastPanel';
import { Container, Row, Col } from 'reactstrap';
import AuthenticationButton from './components/AuthenticationButton/AuthenticationButton';

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user: this.props.auth0 != null ? this.props.auth0 : 0,
            tzOffset: '',
            clients: [],
            userPermissions: [],
            userClients: [],
            userEmployee: {},
            error: false,
        }

        this.viewAppLogs = false;
        this.viewInfoLogs = false;
        this.toastCallback = false;

        this.schema = {
            parents: [
                {
                    name: 'Address', headers: ['Address 1', 'Address 2', 'City', 'State', 'Postal Code', 'Website', 'Portfolio Management System'], sections: [
                        {
                            name: 'Address', stateSection: 'address', limit: 1, fields: [
                                { hint: 'Address 1', name: 'address1', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                { hint: 'Address 2', name: 'address2', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                { hint: 'City', name: 'city', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                { hint: 'State', name: 'state', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                { hint: 'Postal Code', name: 'postalCode', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                { hint: 'Website', name: 'website', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                {
                                    hint: 'Portfolio Management System', name: 'portfolioManagementSystem', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                    options: ['Axys', 'APX', 'CyGem', 'Morningstar', 'PortfolioCenter', 'Black Diamond']
                                },
                            ]
                        },
                    ]
                },
                {
                    name: 'Contacts', headers: ['First Name', 'Last Name', 'Title', 'Email', 'Notifications', 'Phone', 'Type', 'Inactive'], sections: [
                        {
                            name: 'Contacts', stateSection: 'contacts', limit: 0, fields: [
                                { hint: 'First Name', name: 'firstName', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                { hint: 'Last Name', name: 'lastName', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                { hint: 'Title', name: 'title', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                { hint: 'Email', name: 'email', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                { hint: 'Notifications', name: 'notifications', col: 1, type: 'checkbox', classNames: '', validation: '', inputMask: '' },
                                { hint: 'Phone', name: 'phone', col: 4, type: 'phone', classNames: '', validation: '', inputMask: '' },
                                {
                                    hint: 'Type', name: 'type', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                    options: ['Primary Operations', 'Secondary Operations', 'Billing', 'Other']
                                },
                                { hint: 'Inactive', name: 'inactive', col: 1, type: 'checkbox', classNames: '', validation: '', inputMask: '' },
                            ]
                        },
                    ]
                },
                {
                    name: 'Customer Detail Information', headers: ['Portfolio Management System', 'System Expiration Date', 'Trading System', 'Data Feed Source',
                        'Reference Data Source', 'Recurring Client Call Frequency', 'Last Recurring Client Call', 'Customer Notes', 'Customer Connectivity Method'], sections: [
                            {
                                name: 'Customer Details', stateSection: 'customerDetails', limit: 1, fields: [
                                    { hint: 'Portfolio Management System', name: 'portfolioManagementSystem', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                    { hint: 'System Expiration Date', name: 'systemExpirationDate', col: 4, type: 'date', classNames: '', validation: '', inputMask: '' },
                                    { hint: 'Trading System', name: 'tradingSystem', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                    { hint: 'Data Feed Source', name: 'dataFeedSource', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                    { hint: 'Reference Data Source', name: 'referenceDataSource', col: 4, type: 'text', classNames: '', validation: '', inputMask: '' },
                                    {
                                        hint: 'Recurring Client Call Frequency', name: 'recurringClientCallFrequency', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                        options: ['Monthly', 'Quarterly', 'Bi-annual', 'Annual']
                                    },
                                    { hint: 'Last Recurring Client Call', name: 'lastRecurringClientCall', col: 4, type: 'date', classNames: '', validation: '', inputMask: '' },
                                    { hint: 'Customer Notes', name: 'customerNotes', col: 4, type: 'textarea', classNames: '', validation: '', inputMask: '' },
                                    {
                                        hint: 'Customer Connectivity Method', name: 'customerConnectivityMethod', col: 4, type: 'select', classNames: '', validation: '', inputMask: '',
                                        options: ['VPN / RDP', 'RDP', 'GTM', 'Website', 'Cloud']
                                    },
                                ]
                            },
                        ]
                },
            ]
        }
    }

    componentDidMount = () => {
        this.log('App.js/componentDidMount');
        this.getClients();
    }

    checkPermission = (permission) => {
        this.info('EmployeesContainer.js/checkPermission (permission)', permission);
        const permissionGranted =
            permission === '' || permission == null ||
            this.state.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    log = (...args) => {
        if (!this.viewAppLogs) return;
        const colors = ['#BADA55', '#F5B7B1', '#F5CBA7', '#F9E79F', '#ABEBC6', '#A3E4D7', '#AED6F1', '#D7BDE2']
        const method = args.shift();
        const page = method.split('/')[0];
        let color = '';
        switch (page) {
            // case "Home.js": color = colors[3]; break;
            default: color = colors[0];
        }
        console.log('%c' + method + '\n', 'font-weight: bold; color: ' + color + ';', ...args)
    }

    info = (...args) => {
        if (!this.viewInfoLogs) return;
        const colors = ['#888888', '#F5CBA7', '#F9E79F', '#ABEBC6', '#A3E4D7', '#AED6F1', '#D7BDE2']
        const method = args.shift();
        const page = method.split('/')[0];
        let color = '';
        switch (page) {
            // case "Home.js": color = colors[3]; break;
            default: color = colors[0];
        }
        console.log('%c' + method + '\n', 'font-weight: bold; color: ' + color + ';', ...args)
    }

    addToast = (str, delay, color) => {
        this.log('App.js/addToast (str,delay,color)', str, delay, color)
        if (this.toastCallback != null && typeof (this.toastCallback) === 'function') this.toastCallback({
            str: str,
            delay: (delay != null ? delay : 5),
            color: (color != null ? color : 'primary'),
            timestamp: new Date()
        })
    }

    addCallback = (cb) => {
        this.log('App.js/addCallback (cb)', cb)
        this.toastCallback = cb;
    }

    isJSON = (str) => {
        this.log('App.js/isJSON (str)', str)
        if (str === '' || str == null || str === undefined || str.length < 2) return false;
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    isFieldNull = (val, checkbox) => {
        this.info('App.js/isFieldNull (val, checkbox)', val, checkbox);
        return (val != null) ? val : ((checkbox != null && checkbox) ? false : '');
    }

    getClients = () => {
        this.log('App.js/getClients');
        fetch('/api/clients/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) {
                    return;
                }
                if (results.success) {
                    this.setState({
                        clients: results.data,
                    });
                } else {
                    this.setState({
                        error: true,
                    });
                    this.addToast('Unable to retrieve client data.', 0, 'danger');
                }
            })
            .catch(() => {
                this.addToast('An error has occurred.', 5, 'danger');
            })
    }

    refreshUser = (cb, sub = this.state.user) => {
        this.log('App.js/refreshUser (sub)',sub)
        fetch('/api/users/' + sub, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        // user: sub,
                        tzOffset: results.data.tzOffset,
                        userPermissions: results.data.permissions,
                        userClients: results.data.clients,
                        userEmployee: results.data.employee != null && results.data.employee.length === 1 ? results.data.employee[0] : {},
                        userAppAuthenticated: true
                    }, () => {
                        this.viewAppLogs = this.checkPermission('View App Logs');
                        this.viewInfoLogs = this.checkPermission('View Info Logs');
                        if (cb != null) cb();
                    });
                } else {
                    this.setState({
                        error: true,
                    }, () => { if (cb != null) cb(); });
                    this.addToast('Unable to authenticate user.', 0, 'danger');
                }
            }).catch(() => {
                this.addToast('An error has occurred.', 5, 'danger');
                if (cb != null) cb();
            })
    }

    ping = () => {
        this.log('App.js/ping')
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 2500)

        fetch('/ping', {
            signal: controller.signal,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(() => {
                clearTimeout(timeoutId);
            })
            .catch(() => {
                clearTimeout(timeoutId);
                this.addToast('Unable to reach server.', 2, 'danger');
            })
    }

    handleChangeClientToken = (token) => {
        this.log('App.js/handleChangeClientToken (token)', token)
        localStorage.setItem('clientToken', token);
        this.setState({
            clientToken: token,
            loadMappings: true
        }, () => this.init());
    }

    handleChangeUserEmployee = (obj) => {
        this.log('App.js/handleChangeUserEmployee (obj)', obj)
        const keys = ['primaryCustomers', 'secondaryCustomers', 'teamCustomers'];
        this.setState((prevState) => {
            let userEmployee = { ...prevState.userEmployee }
            keys.forEach(key => {
                userEmployee[key].filter(client => client.clientId === obj.clientId && client.workflows != null && client.workflows.length > 0)
                    .forEach(client => client.workflows.filter(workflow => workflow.id === obj.workflowId)
                        .forEach(workflow => {
                            if (obj.clientTaskId != null && workflow.tasks != null && workflow.tasks.length > 0) {

                            } else if (obj.clientTaskId == null && workflow.timeTracking != null && workflow.timeTracking.length > 0) {
                                workflow.timeTracking.filter(time => time.clientTaskTimeTrackingId === obj.clientTaskTimeTrackingId)
                                    .forEach(time => {
                                        time.beginTimestamp = obj.beginTimestamp;
                                        time.endTimestamp = obj.endTimestamp
                                    })
                            }
                        })
                    )
            })
            return userEmployee;
        })
    }

    render = () => {
        this.log('App.js/render');
        this.ping();
        const auth0 = this.props.auth0;
        if (auth0 == null || this.state.userPermissions.length === 0) {
            this.refreshUser(null, this.props.auth0);
        }
        return (<>
            {this.state.user != null && this.state.clients.length > 0 ?
                <Nav
                    {...this.props}
                    user={this.state.user}
                    tzOffset={this.state.tzOffset}
                    userPermissions={this.state.userPermissions}
                    userClients={this.state.userClients}
                    userEmployee={this.state.userEmployee}
                    clients={this.state.clients}
                    refreshUser={this.refreshUser}
                    isJSON={this.isJSON}
                    isFieldNull={this.isFieldNull}
                    addToast={this.addToast}
                    isAuthenticated={this.props.auth0}
                    getClients={this.getClients}
                    log={this.log}
                    info={this.info}
                    ping={this.ping}
                    handleChangeUserEmployee={this.handleChangeUserEmployee}
                    companySchema={this.schema}
                /> :
                <>
                    <nav className="Nav">
                        <Container fluid>
                            <Row>
                                <Col className="text-right">
                                    <AuthenticationButton login={this.props.login} logout={this.props.logout} isAuthenticated={this.props.isAuthenticated} />
                                </Col>
                            </Row>
                        </Container>
                    </nav>
                    {this.state.error ? <h1>Application Error, please try again later.</h1> : <></>}
                </>}
            <div className="toastPanel align-bottom">
                <ToastPanel
                    toastArray={this.state.toastArray}
                    addCallback={this.addCallback}
                    log={this.log}
                    info={this.info}
                />
            </div>
        </>
        )
    }
}

export default App;